import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { GetTaskListService } from '../admin/services/get-task-list.service';
import { NgIf, NgFor } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'manual-load-dialog',
    templateUrl: './manual-load-dialog.html',
    styleUrls: ['./manual-load-dialog.scss'],
    imports: [MatDialogTitle, NgIf, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, NgFor]
})
export class ManualLoadDialogData {

  loading: boolean = false;
  complete: boolean = false;
  message: string = '';
  loadedChecklists: any[] = [];
  existingChecklists: any[] = [];
  shiftDate: string = '';
  shift: string = '';

  constructor(
    public dialogRef: MatDialogRef<ManualLoadDialogData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private taskService: GetTaskListService,
    private _snackBar: MatSnackBar
  ) {}

  confirmLoad() {
    this.loading = true;

    this.taskService.manualLoad(this.data.site, this.data.environment, this.data.objectID).subscribe({
      next: (res) => {
        console.log(res, 'checklist')
        this.loading = false;
        this.complete = true;
        this.message = res.Body?.Message || '';
        this.loadedChecklists = res.Body?.LoadedChecklists || [];
        this.existingChecklists = res.Body?.ExistingChecklists || [];
        this.shiftDate = res.Body?.ShiftDate || '';
        this.shift = res.Body?.Shift || '';
      },
      error: (err) => {
        this.loading = false;
        this._snackBar.openFromComponent(ManualLoadErrorSnackBar, {
          duration: 5000,
          data: err?.error?.errorMessage || 'Manual load failed'
        });
      }
    });
  }

  close(refresh: boolean = false) {
    this.dialogRef.close(refresh);
  }
}

@Component({
    selector: 'manual-load-error-snackbar',
    template: "<span style='color: yellow'>{{data}}</span>",
    styles: []
})
export class ManualLoadErrorSnackBar {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}